module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-home pages-inner"
  }, [_c('Loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }), (_vm.props && !_vm.loading) ? _c('div', {
    staticClass: "inner-inner-wrap"
  }, [_c('Header'), _c('div', {
    staticClass: "home_content_wrap"
  }, [_c('div', {
    staticClass: "slider_section"
  }, [_c('div', {
    staticClass: "home_slideshow"
  }, [(_vm.props.acf.homepage_banner_poster_img) ? _c('video', {
    staticClass: "welcomeVid",
    attrs: {
      "preload": "auto",
      "autoplay": "",
      "loop": "",
      "muted": "",
      "playsinline": "",
      "poster": _vm.props.acf.homepage_banner_poster_img
    },
    domProps: {
      "muted": true
    }
  }, [(_vm.props.acf.homepage_banner_poster_img) ? _c('img', {
    staticClass: "novid",
    attrs: {
      "src": _vm.props.acf.homepage_banner_poster_img,
      "alt": "you browser lacks html5 video support"
    }
  }) : _vm._e(), (_vm.props.acf.homepage__banner_video_url) ? _c('source', {
    attrs: {
      "type": "video/mp4",
      "src": _vm.props.acf.homepage__banner_video_url
    }
  }) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "callouts_banner"
  }, [(_vm.props.acf.girl_with_earphone_img) ? _c('img', {
    staticClass: "ornamentBG",
    attrs: {
      "src": _vm.props.acf.girl_with_earphone_img,
      "alt": "",
      "width": "989"
    }
  }) : _vm._e(), (_vm.props.acf.callout_list) ? _c('u-animate-container', {
    staticClass: "wow-wrap level"
  }, _vm._l((_vm.props.acf.callout_list), function(CalloutList, i) {
    return _c('u-animate', {
      staticClass: "callout_list",
      attrs: {
        "name": "bounceInUp",
        "delay": 0 + i / 4 + "s",
        "duration": "1.2s",
        "iteration": 1,
        "offset": 0,
        "animateclass": "animated",
        "begin": false
      }
    }, [_c('router-link', {
      attrs: {
        "to": CalloutList.url
      }
    }, [_c('img', {
      staticClass: "decoration",
      attrs: {
        "src": CalloutList.image,
        "alt": "",
        "width": "238"
      }
    }), _c('h2', {
      staticClass: "topic",
      domProps: {
        "innerHTML": _vm._s(CalloutList.text)
      }
    })])], 1)
  })) : _vm._e()], 1)]), _c('div', {
    staticClass: "welcome_section",
    attrs: {
      "id": "welcome_id"
    }
  }, [_c('div', {
    staticClass: "container_manual clearfix"
  }, [_c('span', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypoint,
        options: _vm.intersectionOptions
      }),
      expression: "{ active: true, callback: onWaypoint, options: intersectionOptions }"
    }],
    attrs: {
      "id": "fishouter"
    }
  }, [(_vm.props.acf.welcome_fish_img) ? _c('img', {
    staticClass: "ornament",
    attrs: {
      "id": "fish1",
      "src": _vm.props.acf.welcome_fish_img,
      "alt": "",
      "width": "216",
      "height": "151"
    }
  }) : _vm._e()]), (_vm.props.acf.welcome_content) ? _c('div', {
    staticClass: "welcome_content",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.welcome_content)
    }
  }) : _vm._e()])]), _c('div', {
    staticClass: "service_section"
  }, [_c('div', {
    staticClass: "service1"
  }, [(_vm.props.acf.service_list) ? _c('u-animate-container', {
    staticClass: "wow-wrap service_wrap container_manual"
  }, _vm._l((_vm.props.acf.service_list), function(ServiceList, i) {
    return _c('u-animate', {
      staticClass: "service_list",
      attrs: {
        "name": "bounceIn",
        "delay": 0 + i / 4 + "s",
        "duration": "1.2s",
        "iteration": 1,
        "offset": 0,
        "animateclass": "animated",
        "begin": false
      }
    }, [_c('router-link', {
      attrs: {
        "to": ServiceList.url
      }
    }, [_c('div', {
      staticClass: "info"
    }, [_c('h2', {
      staticClass: "topic",
      domProps: {
        "innerHTML": _vm._s(ServiceList.title)
      }
    }), _c('div', {
      staticClass: "voluble",
      domProps: {
        "innerHTML": _vm._s(ServiceList.content)
      }
    })])])], 1)
  })) : _vm._e()], 1), (_vm.props.acf.homepage_testimonial_bg) ? _c('div', {
    staticClass: "service2",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.homepage_testimonial_bg + ')'
    }),
    attrs: {
      "id": "service_fish_id"
    }
  }, [_c('span', {
    directives: [{
      name: "waypoint",
      rawName: "v-waypoint",
      value: ({
        active: true,
        callback: _vm.onWaypoint1,
        options: _vm.intersectionOptions1
      }),
      expression: "{ active: true, callback: onWaypoint1, options: intersectionOptions1 }"
    }],
    attrs: {
      "id": "fishouter"
    }
  }, [(_vm.props.acf.test_fish) ? _c('img', {
    staticClass: "ornament",
    attrs: {
      "id": "fish3",
      "src": _vm.props.acf.test_fish,
      "alt": "",
      "width": "264"
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "info"
  }, [(_vm.props.acf.testimonial_title) ? _c('h2', {
    staticClass: "topic",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.testimonial_title)
    }
  }) : _vm._e(), _c('u-animate-container', {
    staticClass: "wow-wrap testimonial_slider"
  }, [(_vm.props.acf.testimonial_list) ? _c('div', {
    staticClass: "testimonial-list"
  }, [_c('u-animate', {
    attrs: {
      "name": "bounceIn",
      "delay": "0.25s",
      "duration": "1.2s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOption1
    }
  }, _vm._l((_vm.props.acf.testimonial_list), function(testimonailSlider) {
    return _c('swiper-slide', [(_vm.props.acf.testimonial_read_more_url) ? _c('router-link', {
      attrs: {
        "to": _vm.props.acf.testimonial_read_more_url
      }
    }, [_c('span', {
      staticClass: "testimonial_content",
      domProps: {
        "innerHTML": _vm._s(testimonailSlider.description)
      }
    }), _c('span', [_c('span', [_vm._v(" - ")]), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(testimonailSlider.title)
      }
    })])])]) : _vm._e()], 1)
  }))], 1)], 1) : _vm._e()]), _c('u-animate-container', {
    staticClass: "wow-wrap links"
  }, [_c('u-animate', {
    staticClass: "btn_testi",
    attrs: {
      "name": "bounceInUp",
      "delay": "0.3s",
      "duration": "1.3s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [(_vm.props.acf.testimonial_read_more_url) ? _c('router-link', {
    attrs: {
      "to": _vm.props.acf.testimonial_read_more_url
    }
  }, [(_vm.props.acf.testimonial_read_more_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.testimonial_read_more_text)
    }
  }) : _vm._e()]) : _vm._e()], 1), _c('u-animate', {
    staticClass: "btn_testi",
    attrs: {
      "name": "bounceInUp",
      "delay": "0.6s",
      "duration": "1.3s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [(_vm.props.acf.google_plus_review_url) ? _c('a', {
    attrs: {
      "href": _vm.props.acf.google_plus_review_url,
      "target": "_blank"
    }
  }, [(_vm.props.acf.google_plus_review_text) ? _c('span', {
    staticClass: "no-after",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.google_plus_review_text)
    }
  }) : _vm._e(), _c('span', {
    staticClass: "icon fab fa-google",
    attrs: {
      "aria-label": "google"
    }
  })]) : _vm._e()]), _c('u-animate', {
    staticClass: "btn_testi",
    attrs: {
      "name": "bounceInUp",
      "delay": "0.9s",
      "duration": "1.3s",
      "iteration": 1,
      "offset": 0,
      "animateclass": "animated",
      "begin": false
    }
  }, [(_vm.props.acf.fb_url) ? _c('a', {
    attrs: {
      "href": _vm.props.acf.fb_url,
      "target": "_blank"
    }
  }, [(_vm.props.acf.fb_text) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.fb_text)
    }
  }) : _vm._e()]) : _vm._e()])], 1)], 1)]) : _vm._e()])]), _c('Footer')], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-667b7510","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/home/home.pug
// module id = 602
// module chunks = 1